// Install fonts
import React, { Suspense } from 'react';
import '@fontsource/reddit-sans/400.css';
import '@fontsource/work-sans/400.css';
import '@fontsource/work-sans/600.css';
import './src/styles/main.scss';
import { PrismicPreviewProvider } from 'gatsby-plugin-prismic-previews';
import { getRepositoryConfigs, isPrismicPreviewEnabled } from './src/config/prismic-preview';

export const wrapRootElement = ({ element }) => {
    if (!isPrismicPreviewEnabled()) {
        return element;
    }
    return (
        <PrismicPreviewProvider repositoryConfigs={getRepositoryConfigs()}>
            <Suspense fallback={null}>{element}</Suspense>
        </PrismicPreviewProvider>
    );
};

export const onClientEntry = async () => {
    if (typeof IntersectionObserver === `undefined`) {
        await import(`intersection-observer`);
    }
};
